<div class="container">
    <div class="content">
        <img src="assets/images/resend-email/checked-icon.svg" alt="Success" class="success-icon">
        <h2>Password updated</h2>
        <p>You can now log in with your new password.</p>
        <a class="btn-primary d-block" routerLink="/login">Log In</a>
    </div>
</div>
